import type {
    AcademyBadge,
    BadgeType,
    DoceboCourseStatus,
    TrainingsListingItem,
    TrainingStatusBadgeType,
    TrainingStatusLabelKey
} from '~/types/academy/baseTraining';
import { TRAINING_STATUS_LABEL_KEYS } from '~/types/academy/baseTraining';
import { BADGE_LABEL_KEYS } from '~/utils/academy/trainings/doceboTrainingBadges';

const badgeIconByType: Record<BadgeType, string> = {
    inPerson: 'lucide:user',
    liveWebinar: 'lucide:monitor-play',
    eLearning: 'lucide:laptop',
    prize: 'lucide:award',
    notStarted: '',
    inProgress: '',
    completed: '',
    cme: '',
    new: '',
    reminder: '',
    certificate: 'lucide:award'
};

export const getBadgeIconByType = (badgeType: BadgeType) => {
    return badgeIconByType[badgeType] || '';
};

export const getTrainingStatusBadgeType = (
    status: DoceboCourseStatus | null | undefined
): TrainingStatusBadgeType | null => {
    if (!status) {
        return null;
    }

    if (status === 'completed') {
        return 'completed';
    }

    if (status === 'in_progress') {
        return 'inProgress';
    }

    return 'notStarted';
};

export const getTrainingStatusLabelKey = (
    status: DoceboCourseStatus | null | undefined
): TrainingStatusLabelKey | null => {
    const badgeType = getTrainingStatusBadgeType(status);

    if (!badgeType) {
        return null;
    }

    return TRAINING_STATUS_LABEL_KEYS[badgeType];
};

export function enrichTeaserBadges(item: TrainingsListingItem): AcademyBadge[] {
    const badges = [...item.badges];

    if (item.hasCertificate) {
        badges.push({ type: 'certificate' });
    }

    if (!item.createdAt) {
        return badges;
    }

    const createdAt = new Date(item.createdAt);
    const diffTime = Date.now() - createdAt.getTime();
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;

    if (diffTime >= 0 && diffTime <= fourteenDays) {
        badges.push({ type: 'new', labelKey: BADGE_LABEL_KEYS.new });
    }

    return badges;
}

export function removeDuplicateBadges(badges: AcademyBadge[]): AcademyBadge[] {
    return badges.filter((badge, index, self) => index === self.findIndex((b) => b.type === badge.type));
}
